// src/cms/video-upload/view/video-list-container.jsx
import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import CircularProgress from "@material-ui/core/CircularProgress";
import VideoEditDialog from "./video-edit-dialog";
import VideoDeleteDialog from "./video-delete-dialog";

class VideoListContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      videos: [],
      total: 0,
      page: 0,
      perPage: 10,
      loading: false,
      search: "",
      statusFilter: "",
      error: "",
      // Edit dialog
      editDialogOpen: false,
      editVideo: null,
      // Delete dialog
      deleteDialogOpen: false,
      deleteVideo: null,
      // Preview dialog
      previewDialogOpen: false,
      previewVideo: null,
      // Copy tooltip
      copiedId: null,
    };
    this._searchTimeout = null;
    this.fetchVideos = this.fetchVideos.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
  }

  // --- helpers (same pattern as create-new-article-container) ---
  getAccessToken() {
    try {
      return localStorage.getItem("accessToken") || "";
    } catch (e) {
      return "";
    }
  }

  getActiveDomainObj() {
    var login = this.props && this.props.login ? this.props.login : null;
    if (!login || !login.user) return null;
    return login.user.activeDomain || null;
  }

  getDomainId() {
    var ad = this.getActiveDomainObj();
    if (!ad) return null;
    return ad.domain_id || ad.domainId || ad.id || null;
  }

  getApiBase() {
    var base =
      typeof process !== "undefined" &&
      process.env &&
      process.env.REACT_APP_BLUE_SERVER
        ? process.env.REACT_APP_BLUE_SERVER
        : "";
    if (base && base.charAt(base.length - 1) === "/") base = base.slice(0, -1);
    return base;
  }
  // -----------------------------------------------------------

  componentDidMount() {
    this.fetchVideos();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.refreshKey !== this.props.refreshKey) {
      this.fetchVideos();
    }
  }

  fetchVideos() {
    var domainId = this.getDomainId();
    if (!domainId) domainId = 9704;

    var apiBase = this.getApiBase() || "http://localhost:4000";
    var accessToken = this.getAccessToken();

    var params = [];
    params.push("page=" + (this.state.page + 1));
    params.push("perPage=" + this.state.perPage);
    if (this.state.search) {
      params.push("search=" + encodeURIComponent(this.state.search));
    }
    if (this.state.statusFilter !== "") {
      params.push("status=" + this.state.statusFilter);
    }

    var url =
      apiBase +
      "/article/" +
      String(domainId) +
      "/videos?" +
      params.join("&");

    var self = this;
    this.setState({ loading: true, error: "" });

    axios
      .get(url, {
        headers: { Authorization: accessToken || "" },
        timeout: 30000,
      })
      .then(function (res) {
        var data = res.data && res.data.result ? res.data.result : {};
        self.setState({
          videos: data.videos || [],
          total: data.total || 0,
          loading: false,
        });
      })
      .catch(function (err) {
        console.error("Failed to fetch videos:", err);
        var msg = "Failed to load videos.";
        try {
          if (err && err.response && err.response.data) {
            msg +=
              " " +
              (typeof err.response.data === "string"
                ? err.response.data
                : err.response.data.message || JSON.stringify(err.response.data));
          }
        } catch (e2) {}
        self.setState({ loading: false, error: msg });
      });
  }

  handleSearchChange(e) {
    var value = e.target.value;
    this.setState({ search: value, page: 0 });
    // Debounce search
    if (this._searchTimeout) clearTimeout(this._searchTimeout);
    this._searchTimeout = setTimeout(
      function () {
        this.fetchVideos();
      }.bind(this),
      400
    );
  }

  handleStatusChange(e) {
    this.setState({ statusFilter: e.target.value, page: 0 }, function () {
      this.fetchVideos();
    });
  }

  handleChangePage(event, newPage) {
    this.setState({ page: newPage }, function () {
      this.fetchVideos();
    });
  }

  handleChangeRowsPerPage(event) {
    this.setState(
      { perPage: parseInt(event.target.value, 10), page: 0 },
      function () {
        this.fetchVideos();
      }
    );
  }

  openEditDialog(video) {
    this.setState({ editDialogOpen: true, editVideo: video });
  }

  closeEditDialog() {
    this.setState({ editDialogOpen: false, editVideo: null });
  }

  openDeleteDialog(video) {
    this.setState({ deleteDialogOpen: true, deleteVideo: video });
  }

  closeDeleteDialog() {
    this.setState({ deleteDialogOpen: false, deleteVideo: null });
  }

  openPreviewDialog(video) {
    this.setState({ previewDialogOpen: true, previewVideo: video });
  }

  closePreviewDialog() {
    this.setState({ previewDialogOpen: false, previewVideo: null });
  }

  copyVideoUrl(video) {
    var slug = video.slug || "";
    var url = "https://news.meaww.com/video/" + slug;
    try {
      navigator.clipboard.writeText(url);
      this.setState({ copiedId: video.id });
      setTimeout(
        function () {
          this.setState({ copiedId: null });
        }.bind(this),
        2000
      );
    } catch (e) {
      console.error("Failed to copy:", e);
    }
  }

  formatDate(dateStr) {
    if (!dateStr) return "—";
    try {
      var d = new Date(dateStr);
      return d.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    } catch (e) {
      return dateStr;
    }
  }

  formatDuration(seconds) {
    if (!seconds && seconds !== 0) return "—";
    var total = Math.round(Number(seconds));
    var m = Math.floor(total / 60);
    var s = total % 60;
    return m + ":" + (s < 10 ? "0" : "") + s;
  }

  getStatusLabel(status) {
    switch (status) {
      case 4:
        return { label: "Live", color: "#116329", bg: "#e6ffec" };
      case -2:
        return { label: "Deleted", color: "#82071e", bg: "#fff0f0" };
      case 0:
        return { label: "Draft", color: "#57606a", bg: "#f6f8fa" };
      default:
        return { label: "Status " + status, color: "#57606a", bg: "#f6f8fa" };
    }
  }

  render() {
    var self = this;
    var s = this.state;

    return (
      <div style={wrapperStyle}>
        <h2 style={{ marginTop: 0, marginBottom: 16 }}>Videos</h2>

        {/* Toolbar: search + status filter */}
        <div style={toolbarStyle}>
          <TextField
            placeholder="Search by title..."
            value={s.search}
            onChange={this.handleSearchChange}
            style={{ flex: 1, minWidth: 200 }}
            margin="dense"
            variant="outlined"
          />
          <Select
            value={s.statusFilter}
            onChange={this.handleStatusChange}
            displayEmpty
            style={{ minWidth: 140, marginLeft: 12 }}
            variant="outlined"
            margin="dense"
          >
            <MenuItem value="">All (excl. deleted)</MenuItem>
            <MenuItem value="4">Live</MenuItem>
            <MenuItem value="-2">Deleted</MenuItem>
            <MenuItem value="0">Draft</MenuItem>
          </Select>
        </div>

        {/* Error */}
        {s.error ? <div style={errorStyle}>{s.error}</div> : null}

        {/* Loading */}
        {s.loading ? (
          <div style={{ textAlign: "center", padding: 32 }}>
            <CircularProgress size={32} />
          </div>
        ) : null}

        {/* Table */}
        {!s.loading ? (
          <Paper style={{ overflowX: "auto" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={thStyle}>Thumbnail</TableCell>
                  <TableCell style={thStyle}>Title</TableCell>
                  <TableCell style={thStyle}>Brand</TableCell>
                  <TableCell style={thStyle}>Status</TableCell>
                  <TableCell style={thStyle}>Duration</TableCell>
                  <TableCell style={thStyle}>Created</TableCell>
                  <TableCell style={thStyle}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {s.videos.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} style={{ textAlign: "center", color: "#57606a", padding: 24 }}>
                      No videos found.
                    </TableCell>
                  </TableRow>
                ) : null}
                {s.videos.map(function (video) {
                  var statusInfo = self.getStatusLabel(video.status);
                  var thumbSrc =
                    video.s3ThumbnailUrl || video.thumbnailUrl || "";
                  return (
                    <TableRow key={video.id} hover>
                      <TableCell style={{ padding: "8px 12px" }}>
                        {thumbSrc ? (
                          <img
                            src={thumbSrc}
                            alt=""
                            style={thumbnailStyle}
                          />
                        ) : (
                          <div style={noThumbStyle}>No thumb</div>
                        )}
                      </TableCell>
                      <TableCell style={{ padding: "8px 12px", maxWidth: 260 }}>
                        <div
                          style={{
                            fontWeight: 500,
                            fontSize: 14,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                          title={video.title || ""}
                        >
                          {video.title || "(untitled)"}
                        </div>
                        <div style={{ fontSize: 12, color: "#57606a", marginTop: 2 }}>
                          {video.slug || ""}
                        </div>
                      </TableCell>
                      <TableCell style={{ padding: "8px 12px" }}>
                        <span style={chipStyle}>{video.brand || "—"}</span>
                      </TableCell>
                      <TableCell style={{ padding: "8px 12px" }}>
                        <span
                          style={{
                            ...chipStyle,
                            color: statusInfo.color,
                            background: statusInfo.bg,
                          }}
                        >
                          {statusInfo.label}
                        </span>
                      </TableCell>
                      <TableCell style={{ padding: "8px 12px", fontSize: 13 }}>
                        {self.formatDuration(video.durationSeconds)}
                      </TableCell>
                      <TableCell style={{ padding: "8px 12px", fontSize: 13 }}>
                        {self.formatDate(video.dateCreated)}
                      </TableCell>
                      <TableCell style={{ padding: "8px 4px", whiteSpace: "nowrap" }}>
                        {video.playbackUrl || video.mp4Url || video.originalMp4Url ? (
                          <Tooltip title="Preview">
                            <IconButton
                              onClick={function () {
                                self.openPreviewDialog(video);
                              }}
                              style={{ padding: 6 }}
                            >
                              <PlayArrowIcon style={{ fontSize: 18, color: "#1f6feb" }} />
                            </IconButton>
                          </Tooltip>
                        ) : null}
                        <Tooltip title="Edit">
                          <IconButton
                            onClick={function () {
                              self.openEditDialog(video);
                            }}
                            style={{ padding: 6 }}
                          >
                            <EditIcon style={{ fontSize: 18 }} />
                          </IconButton>
                        </Tooltip>
                        {video.status !== -2 ? (
                          <Tooltip title="Delete">
                            <IconButton
                              onClick={function () {
                                self.openDeleteDialog(video);
                              }}
                              style={{ padding: 6 }}
                            >
                              <DeleteIcon style={{ fontSize: 18 }} />
                            </IconButton>
                          </Tooltip>
                        ) : null}
                        {video.slug ? (
                          <Tooltip title="Open on website">
                            <IconButton
                              onClick={function () {
                                window.open(
                                  "https://news.meaww.com/video/" + video.slug,
                                  "_blank"
                                );
                              }}
                              style={{ padding: 6 }}
                            >
                              <OpenInNewIcon style={{ fontSize: 18 }} />
                            </IconButton>
                          </Tooltip>
                        ) : null}
                        {video.slug ? (
                          <Tooltip
                            title={
                              s.copiedId === video.id ? "Copied!" : "Copy URL"
                            }
                          >
                            <IconButton
                              onClick={function () {
                                self.copyVideoUrl(video);
                              }}
                              style={{ padding: 6 }}
                            >
                              <FileCopyIcon style={{ fontSize: 18 }} />
                            </IconButton>
                          </Tooltip>
                        ) : null}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
            <TablePagination
              component="div"
              count={s.total}
              page={s.page}
              onChangePage={this.handleChangePage}
              rowsPerPage={s.perPage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 20, 50]}
            />
          </Paper>
        ) : null}

        {/* Edit Dialog */}
        {s.editDialogOpen && s.editVideo ? (
          <VideoEditDialog
            video={s.editVideo}
            open={s.editDialogOpen}
            onClose={function () {
              self.closeEditDialog();
            }}
            onSaved={function () {
              self.closeEditDialog();
              self.fetchVideos();
            }}
            login={this.props.login}
          />
        ) : null}

        {/* Delete Dialog */}
        {s.deleteDialogOpen && s.deleteVideo ? (
          <VideoDeleteDialog
            video={s.deleteVideo}
            open={s.deleteDialogOpen}
            onClose={function () {
              self.closeDeleteDialog();
            }}
            onDeleted={function () {
              self.closeDeleteDialog();
              self.fetchVideos();
            }}
            login={this.props.login}
          />
        ) : null}

        {/* Preview Dialog */}
        {s.previewDialogOpen && s.previewVideo ? (
          <Dialog
            open={s.previewDialogOpen}
            onClose={function () {
              self.closePreviewDialog();
            }}
            fullWidth
            maxWidth="md"
          >
            <DialogTitle style={{ paddingRight: 48 }}>
              {s.previewVideo.title || "Video Preview"}
              <IconButton
                onClick={function () {
                  self.closePreviewDialog();
                }}
                style={{ position: "absolute", right: 8, top: 8 }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent style={{ padding: "0 24px 24px" }}>
              <div style={previewVideoWrapStyle}>
                <video
                  controls
                  autoPlay
                  style={previewVideoStyle}
                  src={
                    s.previewVideo.playbackUrl ||
                    s.previewVideo.mp4Url ||
                    s.previewVideo.originalMp4Url ||
                    ""
                  }
                  poster={
                    s.previewVideo.s3ThumbnailUrl ||
                    s.previewVideo.thumbnailUrl ||
                    ""
                  }
                >
                  Your browser does not support the video tag.
                </video>
              </div>
              <div style={previewMetaStyle}>
                <div style={{ marginBottom: 6 }}>
                  <strong>Duration:</strong>{" "}
                  {self.formatDuration(s.previewVideo.durationSeconds)}
                </div>
                <div style={{ marginBottom: 6 }}>
                  <strong>Brand:</strong> {s.previewVideo.brand || "\u2014"}
                </div>
                <div style={{ marginBottom: 6 }}>
                  <strong>Resolution:</strong>{" "}
                  {s.previewVideo.width && s.previewVideo.height
                    ? s.previewVideo.width + " x " + s.previewVideo.height
                    : "\u2014"}
                </div>
                {s.previewVideo.description ? (
                  <div style={{ marginBottom: 6 }}>
                    <strong>Description:</strong> {s.previewVideo.description}
                  </div>
                ) : null}
                {s.previewVideo.slug ? (
                  <div>
                    <strong>URL:</strong>{" "}
                    <a
                      href={"https://news.meaww.com/video/" + s.previewVideo.slug}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#1f6feb" }}
                    >
                      {"https://news.meaww.com/video/" + s.previewVideo.slug}
                    </a>
                  </div>
                ) : null}
              </div>
            </DialogContent>
          </Dialog>
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    login: state && state.login ? state.login : {},
  };
}

export default connect(mapStateToProps)(VideoListContainer);

// --- inline styles ---
var wrapperStyle = {
  maxWidth: 1100,
  margin: "24px auto",
  padding: 16,
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif',
};

var toolbarStyle = {
  display: "flex",
  alignItems: "center",
  marginBottom: 16,
  gap: 12,
  flexWrap: "wrap",
};

var thStyle = {
  fontWeight: 600,
  fontSize: 13,
  color: "#1f2328",
  padding: "10px 12px",
  background: "#f6f8fa",
};

var thumbnailStyle = {
  width: 80,
  height: 45,
  objectFit: "cover",
  borderRadius: 4,
  border: "1px solid #e6e6e6",
};

var noThumbStyle = {
  width: 80,
  height: 45,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#f6f8fa",
  borderRadius: 4,
  border: "1px solid #e6e6e6",
  fontSize: 11,
  color: "#8b949e",
};

var chipStyle = {
  display: "inline-block",
  padding: "2px 10px",
  borderRadius: 12,
  fontSize: 12,
  fontWeight: 500,
  background: "#f6f8fa",
  color: "#57606a",
};

var errorStyle = {
  color: "crimson",
  background: "#fff0f0",
  border: "1px solid #ffd6d6",
  padding: "8px 12px",
  borderRadius: 8,
  marginBottom: 12,
  fontSize: 14,
};

var previewVideoWrapStyle = {
  position: "relative",
  width: "100%",
  paddingTop: "56.25%",
  background: "#000",
  borderRadius: 8,
  overflow: "hidden",
};

var previewVideoStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  objectFit: "contain",
};

var previewMetaStyle = {
  marginTop: 16,
  fontSize: 13,
  color: "#1f2328",
  lineHeight: 1.6,
};
